// Compact Feed view — renders a vertical list of FeedRow items.
// Matches design/project/scripts/feed.jsx FeedView component.
import type { EmptyState, FeedPostItem } from "../api";
import type { AuthorMap } from "../useAuthors";
import { FeedEmptyState } from "./FeedEmptyState";
import { FeedRow } from "./FeedRow";

interface Props {
  posts: FeedPostItem[];
  emptyState: EmptyState | null;
  authors?: AuthorMap;
  onOpen?: (id: string) => void;
  /** Post id to play the one-shot "just posted" celebration on, if present. */
  justPostedId?: string | null;
}

export function FeedView({ posts, emptyState, authors, onOpen, justPostedId }: Props) {
  if (!posts.length) {
    return <FeedEmptyState emptyState={emptyState} />;
  }
  return (
    <div className="feedlist" data-testid="feed-view">
      {posts.map((p) => (
        <FeedRow
          key={p.id}
          post={p}
          authors={authors}
          onOpen={onOpen}
          justPosted={p.id === justPostedId}
        />
      ))}
    </div>
  );
}
